<template>
  <div class="contents">
    <audio
      v-if="hasBgm"
      id="bgmSound"
      :src="`${commonPath}sounds/${jsonData.bgm.file}`"
      loop="true"
    />
    <div class="top-menu">
      <img
        class="top-menu-logo"
        :src="`${commonPath}${menuContent.logoPath}`"
        alt="リアルバーチャル ロゴ画像"
        @click="openNewWindow(menuContent.homeUrl, false)"
      >
      <div class="top-menu-title">
        Sample Fireworks Festival
      </div>
      <div class="top-menu-right">
        <div
          class="menu-button box-button"
        >
          <div class="button-content">
            <!-- <i class="fas fa-tasks" /> -->
            <i class="fas fa-question-circle" />
            <p class="menu-button-text">
              スポンサー一覧
            </p>
          </div>
        </div>
        <div
          class="menu-button"
          @click="(bgmStatus) ? setBgmStatus(false) : setBgmStatus(true);"
        >
          <div class="button-content">
            <template v-if="bgmStatus">
              <div class="button-content circle-button volume--on">
                <i class="fas fa-volume-up" />
                <div>ON</div>
              </div>
            </template>
            <template v-else>
              <div class="button-content circle-button volume--off">
                <i class="fas fa-volume-mute" />
                <div>OFF</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="vr-scene">
      <a-scene id="scene">
        <a-assets
          v-if="hasMainVideo"
          id="assets-area"
        >
          <!-- 天球動画 -->
          <video
            id="mainVideo"
            :src="`${routePath}movies/main/${jsonData.mainVideo.file}`"
            preload="auto"
            autoplay
            muted
            loop
            playsinline
            webkit-playsinline
            crossorigin="anonymous"
          />
        </a-assets>
        <!-- main動画(360度動画) -->
        <a-videosphere
          v-if="hasMainVideo"
          id="sphere"
          :radius="jsonData.mainVideo.radius"
          :position="jsonData.mainVideo.position"
          :rotation="jsonData.mainVideo.rotation"
          src="#mainVideo"
        />
        <RoomScene
          ref="room"
          :image-route-path="routePath + 'images/'"
          :glb-route-path="routePath + 'glb/'"
          :json-data="jsonData"
          @setGlbData="setGlbData"
          @loadFlag="loadFlag = true"
          @setConfirmWindow="setConfirmWindow"
          @positionChanged="positionChanged"
        />
        <!-- バス用 初期位置落下防止用床 -->
        <a-plane 
          v-if="jsonData.modelName === 'ff-demo'"
          id="busFloor"
          static-body
          position="-2 0.45 7"
          rotation="-90 0 0"
          width="1"
          height="1"
          material="opacity:0"
        />
      </a-scene>
      <!-- Picture-in-Picture動画設定 -->
      <div
        v-if="hasPipVideo"
        class="pip"
      >
        <video
          id="pipVideo"
          :src="`${routePath}movies/pip/${jsonData.pipVideo.file}`"
          autoplay
          muted
          loop
          playsinline
          webkit-playsinline
          preload="auto"
        />
      </div>
    </div>
    <LoadingView v-if="!loadFlag" />
    <SoundPermission
      v-if="soundPermissionFlag"
      @sound-permission="setBgmStatus(true)"
    />
    <ConfirmWindow
      v-if="confirmWindowFlag"
      :target-title="targetTitle"
      :target-url="targetUrl"
      :window-open="windowTabFlag"
      :custom-window-open="customWindowOpen"
      @close-window="confirmWindowFlag = false"
    />
  </div>
</template>

<script>
import utilsMixin from '../mixins/utils'
import videoAudioMixin from '../mixins/videoAudioMixin'
import LoadingView from '../components/LoadingView'
import SoundPermission from '../components/SoundPermission'
import ConfirmWindow from '../components/ConfirmWindow'
import RoomScene from '../components/RoomScene'
import settingJson from '../assets/setting-ff-demo.json';

export default {
  name: 'FfDemoView',
  components: {
    RoomScene,
    LoadingView,
    SoundPermission,
    ConfirmWindow
  },
  mixins: [utilsMixin, videoAudioMixin],
  props: {},
  data() {
    return {
      title: 'Sample Fireworks Festival',  // ページタイトル
      description: 'リアルバーチャル サンプル花火大会',  // ページ説明
      loadFlag: false,                                    // ロード画面用フラグ
      confirmWindowFlag: false,                           // 遷移先確認画面表示フラグ
      targetTitle: '',                                    // 遷移先タイトル
      targetUrl: '',                                      // 遷移先URL
      windowTabFlag: true,                                // 別タブ起動フラグ true->別タグ
      customWindowOpen: false,                             // 特定ドメインの時に同タブ起動するフラグ true->同タブ
      allJsonData: settingJson,                           // 全てのページの設定情報
      jsonData: '',                                       // ページごとの設定情報
      pageId: this.$route.params.page,                    // ページID
      prevPageId: this.$route.query.prev,                 // 一つ前のページID
      commonPath: '/assets/ff-demo/',                     // 各データの共通パス
      routePath: '/assets/ff-demo/',                      // 各データのルートパス
      secondaryRoutePath: '/assets/ff-demo-page/',        // 子階層の各データのルートパス
      glbData: {},                                        // 子Vueで取得したGLBデータ
      delWarpGlbList: [],                                 // ワープゾーンの土台GLB(使っていないものは削除するために保持)
      faceList: {   // 顔動画
        wavehands: 'wavehands.mp4'
      },
      menuContent: {
        logoPath: 'images/menu-logo.png',
        homeUrl: '/#/ff-demo',
        mapUrl: ''
      },
      jsonRotationY: 0, // rigカメラのY軸回転角度
      roomRig: null, // カメラリグの参照
      roomCamera: null // カメラの参照
    }
  },
  computed: {
    // 初回アクセスフラグを取得
    firstAccess() { return this.$store.getters['CampusStatus/getFirstAccess']; },
    // BGM許可ステータスを取得
    bgmStatus() { return this.$store.getters['CampusStatus/getBgmStatus']; },
    // タッチデバイス判定を取得
    isTouchDevice() { return this.$store.getters['CampusStatus/getTouchDeviceStatus']; }
  },
  watch: {
  },
  created() {
    // 出現位置を設定(建物名を設定) ※※※Custom※※※
    this.setRoomRig('ff-demo', 'ff-demo');
    // 以前の選択を復元（'1' ⇒ ON, '0' ⇒ OFF, null ⇒ 何もしない＝初回）
    const saved = localStorage.getItem('wantVideoSound');
    if (saved === '1' || saved === '0') {
      this.$store.dispatch('CampusStatus/setBgmStatus', saved === '1');
      // もし firstAccess を使っているなら、決定済みであれば false にしておくのも手
      // this.$store.dispatch('CampusStatus/setFirstAccess', false);
    }
  },
  mounted() {
    // タイトルと説明、OGPを設定
    this.changePageContent();
    // フォールバック：ボタン押したら再生
    const playUi = document.getElementById('playUi');
    if (playUi) {
      playUi.addEventListener('click', () => {
        const videoEl = document.getElementById('mainVideo');
        if (videoEl) {
          videoEl.muted = true;
          videoEl.play();
        }
        playUi.style.display = 'none';
      });
    }
    // コントロールボタン操作に必要な情報を設定
    this.jsonRotationY = this.jsonData.rig.rotation.y; // jsonDataからrigのY軸回転角度を取得しjsonRotationYに設定
    this.roomRig = this.$refs.room.$refs.rig; // roomコンポーネントからrigエレメントを取得しroomRigに設定
    this.roomCamera = this.$refs.room.$refs.camera; // roomコンポーネントからcameraエレメントを取得しroomCameraに設定
  },
  methods: {
    /*******************************************
     * ワープゾーンのポジション設定
     ******************************************/
    positionChanged(newPosition) {
      // 設定されているワープゾーンの数だけ繰り返しチェック
      for (let property in this.jsonData.warpList) {
        // 設定ファイルからワープゾーンのポジションを取得
        let xWarpSpot = Math.ceil(this.jsonData.warpList[property].position.x);
        let yWarpSpot = Math.ceil(this.jsonData.warpList[property].position.y);
        let zWarpSpot = Math.ceil(this.jsonData.warpList[property].position.z);
        // ワープゾーンに来たら確認ポップアップを起動(原点から±1m以内の範囲)
        if (
          (newPosition.x >= xWarpSpot - 1 && newPosition.x <= xWarpSpot + 1) &&
          (newPosition.y >= yWarpSpot - 1 && newPosition.y <= yWarpSpot + 1) &&
          (newPosition.z >= zWarpSpot - 1 && newPosition.z <= zWarpSpot + 1)
        ) {
          // ポップアップの処理を呼び出し
          this.setWarpConfirmWindow(property);
        }
      }
    },
    /*******************************************
     * OGPを設定
     ******************************************/
    // ogImagePathを生成する
    ogImagePath() {
      const uri = new URL(window.location.href);
      if (this.pageId === undefined) {
        return `${uri.origin}${this.routePath}images/og_image.png`;
      } else {
        return `${uri.origin}${this.secondaryRoutePath}images/og_image-${this.pageId}.png`;
      }
    },
    /*******************************************
     * 動画のロードが完了したとき
     ******************************************/
    async onloadedVideo(event) {
      let avatarVideo = event.target;
      avatarVideo.muted = true;  // Ensure the video is muted
      try {
        await avatarVideo.play();
      } catch (err) {
        console.log('Failed to autoplay video:', err);
        // Handle autoplay error, for example, by showing a play button
      }
    },
    /*******************************************
     * 子から受け取った建物データを設定
     ******************************************/
    setGlbData(glbData) {
      this.glbData = glbData;
    },
    /*******************************************
     * 別タブでURLを起動
     ******************************************/
    openNewWindow(target, windw = true) {
      if (windw) {
        window.open(target);
      } else {
        location.href = target
        location.reload();
      }
    },
    /*******************************************
     * 画面遷移のConfirm画面呼び出し
     ******************************************/
    setConfirmWindow(target) {
      // URL形式
      if (this.jsonData.linkList[target].url.indexOf('://') === -1) {
        // 自サイトの場合ホストを設定
        this.targetUrl = window.location.protocol + '//' + window.location.host + '/#';
        this.targetUrl += this.jsonData.linkList[target].url;
        // pageIDがある場合はパラメーターに設定
        if (this.pageId !== undefined) this.targetUrl += '?prev=' + this.pageId;
        this.windowTabFlag = false;
      } else {
        // 他サイトの場合はそのままURLを設定
        this.targetUrl = this.jsonData.linkList[target].url;
      }
      // タイトルを設定
      this.targetTitle = this.jsonData.linkList[target].title;
      // confirmウィンドウを起動
      this.confirmWindowFlag = true;
    },
    /*******************************************
     * ワープのConfirm画面呼び出し
     ******************************************/
    setWarpConfirmWindow(target) {
      // URLが設定されていない場合は画面を出さない
      if (!this.jsonData.warpList[target].url) return;
      // URL形式
      if (this.jsonData.warpList[target].url.indexOf('://') === -1) {
        // 自サイトの場合ホストを設定
        this.targetUrl = window.location.protocol + '//' + window.location.host + '/#';
        this.targetUrl += this.jsonData.warpList[target].url;
        // pageIDがある場合はパラメーターに設定
        if (this.pageId !== undefined) this.targetUrl += '?prev=' + this.pageId;
        this.windowTabFlag = false;
      } else {
        // 他サイトの場合はそのままURLを設定
        this.targetUrl = this.jsonData.warpList[target].url;
      }
      // タイトルを設定
      this.targetTitle = this.jsonData.warpList[target].title;
      // confirmウィンドウを起動
      this.confirmWindowFlag = true;
    },
    /*******************************************
     * パーツごとにアニメーションを設定する
     ******************************************/
    setAnimation(animationName) {
      let animationElement = document.getElementById(animationName);
      // ドア左の開くアニメーション
      if (animationElement.id === 'animation-nobody-door-1') {
        animationElement.setAttribute('animation-mixer', 'loop:once;clampWhenFinished:true;clip:open-1;');
      }
      // ドア右の開くアニメーション
      if (animationElement.id === 'animation-nobody-door-2') {
        animationElement.setAttribute('animation-mixer', 'loop:once;clampWhenFinished:true;clip:open-2;');
      }
      // ドア左の開くアニメーション
      if (animationElement.id === 'animation-door-l') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: -1.1;dir: alternate;dur: 2000;loop: false');
      }
      // ドア右の開くアニメーション
      if (animationElement.id === 'animation-door-r') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: 1.1;dir: alternate;dur: 2000;loop: false');
      }
      // プロペラの球体パーツ点滅
      if (animationElement.id === 'nobody-animation-limp') {
        animationElement.setAttribute('animation', 'property: visible; from: true; to: false; dur: 10; loop: true; dir: alternate');
      }
      // 建物内の矢印を前後に動かす
      if (animationElement.id === 'animation-nobody-arrow') {
        animationElement.setAttribute('animation', 'property: object3D.position.z;to: -0.5;dir: alternate;dur: 1000;loop: true');
      }
      if (animationElement.id === 'animation-nobody-arrow1') {
        animationElement.setAttribute('animation', 'property: object3D.position.z;to: -0.5;dir: alternate;dur: 1000;loop: true');
      }
      if (animationElement.id === 'animation-nobody-arrow2') {
        animationElement.setAttribute('animation', 'property: object3D.position.z;to: 0.5;dir: alternate;dur: 1000;loop: true');
      }
      if (animationElement.id === 'animation-nobody-arrow3') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: -0.5;dir: alternate;dur: 1000;loop: true');
      }
      // ワープのピンを設定
      if (animationElement.id === 'animation-nobody-mark') {
        // // 原点にあるものは削除(削除するとmassエラーが出るため)
        // animationElement.remove();
        // 原点にあるものは非表示
        animationElement.setAttribute('visible', 'false');
        // glbファイルの保存先URLを取得
        const glbWarpPath = this.glbData.animation[animationElement.id].path;
        if (!glbWarpPath) return;   // 取得できない場合は処理終了
        // ワープGLBを配置する処理
        const scene = document.getElementById('scene');
        // 設定ファイルのワープリストが存在するだけ繰り返す
        for (const property in this.jsonData.warpList) {
          const warpData = this.jsonData.warpList[property];

          // 設定ファイルのmark が "none" の場合はピンを表示しない
          if (warpData.mark === 'none') continue;

          // ワープのentityを作成して配置
          const warpEntity = document.createElement('a-entity');
          warpEntity.setAttribute('id', property);
          warpEntity.setAttribute('static-body', 'shape:none;');
          warpEntity.setAttribute('gltf-model', glbWarpPath);
          const y = typeof warpData.position.y === 'number' ? warpData.position.y : 0;
          warpEntity.setAttribute('position', warpData.position);
          warpEntity.setAttribute(
            'animation',
            `property: object3D.position.y; from: ${y}; to: ${y - 0.3}; dir: alternate; dur: 1000; loop: true`
          );
          if (warpData.rotation) warpEntity.setAttribute('rotation', warpData.rotation);
          scene.appendChild(warpEntity);
        }
      }

      // プロペラを配置して回転させる
      // animation-propeller-1 を複製配置
      if (animationElement.id === 'animation-propeller-1') {
        // 原点にあるものは非表示
        animationElement.setAttribute('visible', 'false');
        // glbファイルの保存先URLを取得
        const glbPropellerPath =
          this.glbData.animation[animationElement.id].path;
        if (!glbPropellerPath) return;   // 取得できない場合は処理終了
        // ワープGLBを配置する処理
        const scene = document.getElementById('scene');

        // プロペラの配置情報
        const propellers = [
          { id: 'propeller1', position: '7.159 0 -6.148', rotation: '0 0 0' },
          { id: 'propeller2', position: '-7.156 0 -6.148', rotation: '0 0 0' },
          { id: 'propeller3', position: '-7.156 0 6.138', rotation: '0 0 0' },
          { id: 'propeller4', position: '7.159 0 6.138', rotation: '0 0 0' },
        ];

        // 1つずつ生成して配置
        propellers.forEach((data) => {
          const propellerEntity = document.createElement('a-entity');

          // id（個別制御用）
          propellerEntity.setAttribute('id', data.id);

          // animation-propeller-1 の GLB を使う
          propellerEntity.setAttribute('gltf-model', glbPropellerPath);
          // 位置
          propellerEntity.setAttribute('position', data.position);
          // 初期回転
          propellerEntity.setAttribute('rotation', data.rotation);

          // 回転アニメーション
          propellerEntity.setAttribute(
            'animation',
            'property: rotation; from: 0 0 0; to: 0 360 0; dur: 300; easing: linear; loop: true'
          );

          scene.appendChild(propellerEntity);
        });
      }
    }
  }
}
</script>

<style scoped>
.contents {
  height: 100vh;
}

.vr-scene {
  height: 92vh;
}

.top-menu {
  height: 8vh;
  min-height: calc(50px + 10px);
  display: flex;
}

.top-menu-logo {
  cursor: pointer;
  margin-left: 10px;
  padding: 5px 0;
}

.menu-icon {
  display: block;
  max-width: 100%;
  width: 1.25em;
}

.menu-icon .cls-1 {
  fill: #fff;
}

.menu-icon .cls-2 {
  fill: #111D5E;
}

.top-menu-title {
  margin: auto auto auto 10px;
  font-weight: bold;
}

.top-menu-right {
  position: relative;
  display: flex;
  padding: 5px 0;
  margin: auto 10px auto auto;
}

.menu-button {
  background-color: #ffffff;
  margin: auto 10px auto 0;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all ease 0.2s;
}

.button-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.box-button {
  color: #111D5E;
  font-weight: bold;
  border: 1px solid #111D5E;
  border-radius: 2px;
  padding: 12px 25px;
}

.box-button:hover {
  color: #fff;
  background-color: #111D5E;
  border-color: #111D5E;
}

.box-button:hover a.button-content {
  color: #fff;
}

.box-button:hover .menu-icon .cls-1 {
  fill: #111D5E;
}

.box-button:hover .menu-icon .cls-2 {
  fill: #fff;
}

a.button-content {
  color: #111D5E;
  text-decoration: none;
}

.box-button .button-content {
  flex-direction: row;
  gap: 0.5em;
}

.circle-button {
  width: 50px;
  color: #202020;
  line-height: 0.85em;
  border: thin solid #202020;
  border-radius: 50%;
}

.circle-button:hover {
  color: #fff;
  background-color: #202020;
}

.circle-button.volume--on {
  color: #fff;
  background-color: #202020;
}

.circle-button-text {
  font-size: 0.35em;
  white-space: nowrap;
}

/* 画面右下 */
.pip {
  position: fixed;
  right: 16px;
  bottom: 16px;
  width: 240px;
  /* 画面に合わせて調整 */
  aspect-ratio: 16 / 9;
  /* 比率維持 */
  z-index: 10000;
  /* A-Frame の上に */
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .25);
}

/* 画面下中央 */
.pip {
  position: fixed;
  left: 50%;
  /* 中央寄せ */
  bottom: 16px;
  /* 画面下からの距離 */
  transform: translateX(-50%);
  /* X方向中央に合わせる */
  width: 240px;
  aspect-ratio: 16 / 9;
  z-index: 10000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .25);
}

.pip video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media (max-width: 768px) {
  .pip {
    width: 160px;
  }
}

@media screen and (max-width:428px) {

  /* SP 縦画面 */
  .box-button {
    line-height: 1;
    padding: 12px 15px;
  }

  .top-menu {
    font-size: 0.75rem;
  }

  .pip {
    left: auto;
    /* 中央寄せ解除 */
    transform: none;
    /* translateX解除 */
    right: 16px;
    /* 右下 */
    bottom: 16px;
    width: 160px;
  }
}
</style>